/** API minimale du dialog de confirmation de suppression. */
export type DocumentDeleteDialogLike = {
  show(): void;
  close(): void;
};

/**
 * État de confirmation de suppression d'un document stocké
 * (documents-achat / dossier-technique).
 */
export class DocumentDeleteSession<TLigne> {
  ligne?: TLigne;
  deleting = false;
  errorMessage: string | null = null;

  get active(): boolean {
    return this.ligne != null;
  }

  ask(
    ligne: TLigne,
    documentId: string | null | undefined,
    isBusy: boolean,
    dialog?: DocumentDeleteDialogLike
  ): void {
    if (!documentId || isBusy) {
      return;
    }
    this.ligne = ligne;
    this.deleting = false;
    this.errorMessage = null;
    dialog?.show();
  }

  cancel(dialog?: DocumentDeleteDialogLike): void {
    dialog?.close();
    this.ligne = undefined;
    this.deleting = false;
    this.errorMessage = null;
  }

  onDialogCancel(event: Event, dialog?: DocumentDeleteDialogLike): void {
    event.preventDefault();
    this.cancel(dialog);
  }

  startRequest(): void {
    this.deleting = true;
    this.errorMessage = null;
  }

  fail(message: string): void {
    this.deleting = false;
    this.errorMessage = message;
  }
}
